import React, { FC, HTMLAttributes } from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';

import Typography from '../Typography/Typography';

type UploadImagePreviewProps = {
  preview: string;
  handleRemoveImage: () => void;
} & HTMLAttributes<HTMLDivElement>;

export const UploadImagePreview: FC<UploadImagePreviewProps> = ({
  preview,
  handleRemoveImage,
  ...rest
}) => (
  <div
    className="w-[152px] h-[86px] relative overflow-hidden rounded-lg group/preview bg-contain bg-center bg-no-repeat"
    style={{ backgroundImage: `url(${preview})` }}
    {...rest}
  >
    <div
      data-testid="ContentForm-ThumbnailUpload-Overlay"
      className="hidden opacity-0 w-full h-full absolute top-0 left-0 cursor-pointer rounded-lg group-hover/preview:flex group-hover/preview:items-center group-hover/preview:justify-center group-hover/preview:bg-button-hover-upload-change group-hover/preview:opacity-100"
    >
      <Typography className="text-p-xs text-base-popover">Change</Typography>
      <FontAwesomeIcon
        data-testid="ContentForm-ThumbnailUpload-Remove"
        icon="fa-regular fa-trash"
        onClick={(event: any) => {
          event.stopPropagation();
          handleRemoveImage();
        }}
        className="w-6 h-6 absolute text-white p-1 top-1.5 right-1.5 rounded-lg bg-[rgba(255,255,255,0.10)] text-[10px] hover:bg-[rgba(255,255,255,0.30)]"
      />
    </div>
  </div>
);
